import { useAppTheme } from './ThemeContext';
import NoThumbnail from '../assets/images/no-thumbnail.png';
import NoThumbnailLight from '../assets/images/no-thumbnail-light.svg';

function useNoThumbnail(): string {
  const { themeMode } = useAppTheme();

  return themeMode === 'light' ? NoThumbnailLight : NoThumbnail;
}

export default useNoThumbnail;
